"use client";
import { useEffect, useContext } from "react";
import { IndicatorsContext } from "../../(context)/IndicatorsContext";

export const useThreeLevelSelector = () => {
  let {
    data,
    setFilteredData,
    level1Value,
    level2Value,
    setLevelValue1,
    setLevelValue2,
    setLevelValue3,
    setDataSelector1,
    setDataSelector2,
    setDataSelector3,
    setLoading,
  } = useContext(IndicatorsContext);

  // Este efecto se ejecuta cuando se actualiza la variable data, que sólo va a pasar una vez
  // Setea los valores iniciales de los selectores
  useEffect(() => {
    if (data.length === 0) return;
    setLoading(true);
    const d1 = data.filter(({ index }) => index % 100 === 0);
    const inRange = data.filter(
      ({ index }) => index >= level1Value && index <= level1Value + 99
    );
    const d2 = inRange.filter(({ index }) => index % 10 === 0);

    setDataSelector1(d1);
    setDataSelector2([{ index: -1, label: "Todos" }, ...d2]);

    setDataSelector3([{ index: -1, label: "Todos" }, ...inRange]);
    setFilteredData(inRange);
    setLoading(false);
  }, [data]);

  // Esta función se ejecuta cuando se cambia el valor del primer selector
  // Actualiza el segundo y tercer selector
  const handleOnChangeLevel1 = (val) => {
    setLoading(true);
    const value = parseInt(val, 10);
    setLevelValue1(value);
    setLevelValue2(-1);
    setLevelValue3(-1);
    const inRange = data.filter(
      ({ index }) => index >= value && index <= value + 99
    );
    const d2 = inRange.filter(({ index }) => index % 10 === 0);
    setFilteredData(inRange);
    const dataSelector2Aux = [{ index: -1, label: "Todos" }, ...d2];
    const dataSelector3Aux = [{ index: -1, label: "Todos" }, ...inRange];
    setDataSelector2(dataSelector2Aux);
    setDataSelector3(dataSelector3Aux);
    setLoading(false);
  };

  // Esta función se ejecuta cuando se cambia el valor del segundo selector
  // Actualiza el tercer selector
  const handleOnChangeLevel2 = (val) => {
    setLoading(true);
    const value = parseInt(val, 10);
    setLevelValue2(value);

    if (value === -1) {
      handleOnChangeLevel1(level1Value);
      setLevelValue3(-1);
      return;
    }

    const inRange = data.filter(
      ({ index }) => index >= value && index <= value + 9
    );
    const dataSelector3Aux = [{ index: -1, label: "Todos" }, ...inRange];
    setDataSelector3(dataSelector3Aux);
    setFilteredData(inRange);
    setLoading(false);
  };

  // Esta función se ejecuta cuando se cambia el valor del tercer selector
  // Actualiza el valor de filteredData
  const handleOnChangeLevel3 = (val) => {
    setLoading(true);
    const value = parseInt(val, 10);
    setLevelValue3(value);
    if (value === -1) {
      handleOnChangeLevel2(level2Value);
      return;
    }
    const inRange = data.filter(({ index }) => index === value);
    setFilteredData(inRange);
    setLoading(false);
  };

  return {
    handleOnChangeLevel1,
    handleOnChangeLevel2,
    handleOnChangeLevel3,
  };
};
